export default {
  version: '2.1.3',
};
